module.exports = __webpack_public_path__ + "static/grafika3@2x-785334de70e617007b21fdca275dab21.png";